// extracted by mini-css-extract-plugin
module.exports = {"service":"ServicesList_service__2_73n","serviceImg":"ServicesList_serviceImg__3COMh","Shape":"ServicesList_Shape___HCcA"};